// extracted by mini-css-extract-plugin
export default {"editIcon":"Table_editIcon__lOwgy","deleteIcon":"Table_deleteIcon__U9nNS","table":"Table_table__6sIvw","highlighterText":"Table_highlighterText__Ub0YV"};